import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: "DialogConfirmacaoEntrega",
  props: {
    dados: Object,
    dialog: {
      type: Boolean,
      default: false
    },
    confirmation: {
      type: Function,
    },
    onClose: Function
  },
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return { __sfc: true, }
}

})